var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Takeover/Return to SVC")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "handover-option"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-12"
  }, [_c('span', {
    staticClass: "input-group-text scan-tally-button btn-sm btn-primary btn-active",
    class: _vm.change == '0' ? '' : 'active'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.change),
      expression: "change"
    }],
    attrs: {
      "type": "radio",
      "id": "change",
      "name": "change"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.change, 0)
    },
    on: {
      "click": function($event) {
        return _vm.clearAll(false)
      },
      "change": function($event) {
        _vm.change = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Takeover InScan ")])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-text scan-tally-button btn-sm btn-primary",
    class: _vm.change == '1' ? '' : 'active'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.change),
      expression: "change"
    }],
    attrs: {
      "type": "radio",
      "id": "change",
      "name": "change"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.change, 1)
    },
    on: {
      "click": function($event) {
        return _vm.clearAll(true)
      },
      "change": function($event) {
        _vm.change = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Return to SVC ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.change == 1),
      expression: "change == 1"
    }],
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm1('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Handover Mode")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handovermode),
      expression: "handovermode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.handovermode')
    },
    attrs: {
      "name": "handovermode",
      "id": "handovermode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.handovermode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Handover Mode")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Handcarry"
    }
  }, [_vm._v("Handcarry")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Vehicle"
    }
  }, [_vm._v("Vehicle")])])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.handovermode')),
      expression: "errors.has('form-1.handovermode')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v("Please Select Handover Mode.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Vehicle No")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleno),
      expression: "vehicleno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/
      }),
      expression: "{ required: true, regex: /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/ }"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.vehicleno')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle Number",
      "name": "vehicleno",
      "id": "vehicleno"
    },
    domProps: {
      "value": (_vm.vehicleno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleno = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.vehicleno')),
      expression: "errors.has('form-1.vehicleno')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v("Please Enter Valid Vehicle Number.")]), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-8"
  }, [_vm._v("(eg: MH 12 HA 5678 / DL 01 L HA 5678)")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Handover Person Name")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handoverpersonname),
      expression: "handoverpersonname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.handoverpersonname')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Handover Person Name",
      "name": "handoverpersonname",
      "id": "handoverpersonname"
    },
    domProps: {
      "value": (_vm.handoverpersonname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.handoverpersonname = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.handoverpersonname')),
      expression: "errors.has('form-1.handoverpersonname')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v("Please enter Handover Person name.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Job Type")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [(_vm.primaryTabType === 'ShortageShipments') ? _c('input', {
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "type": "text",
      "placeholder": "Ecomm - Reverse - Pickup(RVP)",
      "autocomplete": "off",
      "name": "jobtype"
    }
  }) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.JobType),
      expression: "JobType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "jobtype",
      "id": "jobType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.JobType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.jobTypeSelected(_vm.primaryTabType)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select JobType")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Delivery"
    }
  }, [_vm._v("Ecomm - Forward - Delivery")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTO"
    }
  }, [_vm._v("Ecomm - Forward - RTO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DTO"
    }
  }, [_vm._v("Ecomm - Reverse - Delivery(DTO)")]), _vm._v(" "), (_vm.isRVPFeataureEnableForTesting) ? _c('option', {
    attrs: {
      "value": "RVP"
    }
  }, [_vm._v("Ecomm - Reverse - Pickup(RVP)")]) : _vm._e()])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shippingid")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingId),
      expression: "ShippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|VerifyShippingidFormatForSVC1'),
      expression: "'required|VerifyShippingidFormatForSVC1'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.ShippingId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter ShippingId / AWB",
      "name": "ShippingId",
      "id": "ShippingId"
    },
    domProps: {
      "value": (_vm.ShippingId)
    },
    on: {
      "keypress": _vm.KeycheckFunction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingId = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ShippingId')),
      expression: "errors.has('form-1.ShippingId')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.ShippingId')))]), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-8"
  }, [_vm._v("Maximum 10 shipping IDs permitted for bulk processing.\n                  Multiple shipping IDs can be separated using comma or  next line (↵/,).")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mt-4",
    staticStyle: {
      "margin-left": "120px"
    }
  }, [_c('dummy-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDummyInput),
      expression: "isShowDummyInput"
    }],
    ref: "dummyShipInputBox",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v("Return Shpiments")]), _vm._v(" \n                  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm1
    }
  }, [_vm._v("Reset")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isInScanReturntosvcLoader,
      "text": "Please Wait Shipments Is Returning To Svc..."
    },
    on: {
      "update:active": function($event) {
        _vm.isInScanReturntosvcLoader = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.change == 0),
      expression: "change == 0"
    }],
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm2('form-2')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Process")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.process),
      expression: "process"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-2.process')
    },
    attrs: {
      "name": "process",
      "id": "process"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.process = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.ChangeLabelName]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Process")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "InScan"
    }
  }, [_vm._v("InScan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Shortage"
    }
  }, [_vm._v("Shortage")])])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.process')),
      expression: "errors.has('form-2.process')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v("Please Select Process.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shippingid")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awb),
      expression: "awb"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|VerifyShippingidFormatForSVC2'),
      expression: "'required|VerifyShippingidFormatForSVC2'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-2.awb')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter ShippingId / AWB",
      "name": "awb",
      "id": "awb"
    },
    domProps: {
      "value": (_vm.awb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awb = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.awb')),
      expression: "errors.has('form-2.awb')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('form-2.awb')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-8"
  }, [_vm._v("Maximum 10 shipping IDs permitted for bulk processing.\n                Multiple shipping IDs can be separated using comma or  next line (↵/,).")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mt-4",
    staticStyle: {
      "margin-left": "120px"
    }
  }, [_c('dummy-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDummyInput),
      expression: "isShowDummyInput"
    }],
    ref: "dummyShipInputBox",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.buttonLabel))]), _vm._v(" \n                "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm2
    }
  }, [_vm._v("\n                  Reset\n                ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isInScanLoader,
      "text": "Please wait shipments is inscan processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isInScanLoader = $event
      }
    }
  })], 1)])])])])]), _vm._v(" "), (_vm.change == 1) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "enlarge-css"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.openModal(_vm.modalType)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt",
    attrs: {
      "title": "View full screen"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 tabs-active"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkShippingId('form1')
      }
    }
  }, [_c('b-tabs', {
    staticClass: "tabs-active-style",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Available For Return"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('PendingForReturn')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingList,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingList = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-x": "auto"
    }
  }, [_c('div', [_c('div', [_c('b-tabs', {
    staticClass: "DeliveryshipmentListtab subTabs",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.pendingForReturnBTabs),
      callback: function($$v) {
        _vm.pendingForReturnBTabs = $$v
      },
      expression: "pendingForReturnBTabs"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Delivery"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('PendingForReturn', 'Forward')
      }
    }
  }), _vm._v(" "), (_vm.isRVPFeataureEnableForTesting) ? _c('b-tab', {
    attrs: {
      "title": "RVP"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('PendingForReturn', 'RVP')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "DTO"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('PendingForReturn', 'DTO')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RTO"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('PendingForReturn', 'RTO')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row my-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('PendingForReturn')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending for return list"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalCount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.shippingIdPFR == true ? 'alpha_num' : ''),
      expression: "shippingIdPFR == true ? 'alpha_num' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form1.Shipping Id')
    },
    attrs: {
      "type": "text",
      "id": "ShippingIdPendingForReturn",
      "placeholder": "Search By Shipping id",
      "name": "Shipping Id"
    },
    model: {
      value: (_vm.shippingIdPendingForReturn),
      callback: function($$v) {
        _vm.shippingIdPendingForReturn = $$v
      },
      expression: "shippingIdPendingForReturn"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v(" Search")])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form1.Shipping Id')),
      expression: "errors.has('form1.Shipping Id')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form1.Shipping Id')))])], 1)])]), _vm._v(" "), _c('pending-ForReturn', {
    attrs: {
      "pendingForReturnList": _vm.shipmentList
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginate),
      expression: "showPaginate"
    }],
    ref: "paginateRefs1",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationShipmentListData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "SVC InScan Pending"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('SVCInScanPending')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingList,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingList = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-x": "auto"
    }
  }, [_c('div', [_c('div', [_c('b-tabs', {
    staticClass: "DeliveryshipmentListtab",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.svcInScanPendingBTabs),
      callback: function($$v) {
        _vm.svcInScanPendingBTabs = $$v
      },
      expression: "svcInScanPendingBTabs"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Delivery"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('SVCInScanPending', 'Forward')
      }
    }
  }), _vm._v(" "), (_vm.isRVPFeataureEnableForTesting) ? _c('b-tab', {
    attrs: {
      "title": "RVP"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('SVCInScanPending', 'RVP')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "DTO"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('SVCInScanPending', 'DTO')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RTO"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('SVCInScanPending', 'RTO')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row my-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('SVCInScanPending')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending for return list"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalCount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.shippingIdSVC == true ? 'alpha_num' : ''),
      expression: "shippingIdSVC == true ? 'alpha_num' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form1.Shipping id')
    },
    attrs: {
      "type": "text",
      "id": "ShippingIdSvcInScanPending",
      "placeholder": "Search By Shipping id",
      "name": "Shipping id"
    },
    model: {
      value: (_vm.shippingIdSvcInScanPending),
      callback: function($$v) {
        _vm.shippingIdSvcInScanPending = $$v
      },
      expression: "shippingIdSvcInScanPending"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v(" Search")])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form1.Shipping id')),
      expression: "errors.has('form1.Shipping id')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form1.Shipping id')))])], 1)])]), _vm._v(" "), _c('svcInScan-Pending', {
    attrs: {
      "svcInScanPendingList": _vm.shipmentList
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginate),
      expression: "showPaginate"
    }],
    ref: "paginateRefs2",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationShipmentListData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Pending For Return (RVP)",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentList('ShortageShipments')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingList,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingList = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-x": "auto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('ShortageShipments')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending for return list"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalCount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.shippingIdSS == true ? 'alpha_num' : ''),
      expression: "shippingIdSS == true ? 'alpha_num' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form1.Shipping ID')
    },
    attrs: {
      "type": "text",
      "id": "ShippingIdShortageShipments",
      "placeholder": "Search By Shipping id",
      "name": "Shipping ID"
    },
    model: {
      value: (_vm.shippingIdShortageShipments),
      callback: function($$v) {
        _vm.shippingIdShortageShipments = $$v
      },
      expression: "shippingIdShortageShipments"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v(" Search")])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form1.Shipping ID')),
      expression: "errors.has('form1.Shipping ID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form1.Shipping ID')))])], 1)])]), _vm._v(" "), _c('shortage-Shipments', {
    attrs: {
      "shortagePendingShipments": _vm.shipmentList
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginate),
      expression: "showPaginate"
    }],
    ref: "paginateRefs3",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationShipmentListData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)], 1)], 1)])])]) : _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "enlarge-css"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('PFI')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt",
    attrs: {
      "title": "View full screen"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 tabs-active"
  }, [_c('b-tabs', {
    staticClass: "tabs-active-style",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.takeOverBTabIndex),
      callback: function($$v) {
        _vm.takeOverBTabIndex = $$v
      },
      expression: "takeOverBTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Pending For InScan"
    },
    on: {
      "click": function($event) {
        return _vm.getTakeoverPendingShipmentList()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-x": "auto"
    }
  }, [_c('div', [_c('div', [_c('b-tabs', {
    staticClass: "DeliveryshipmentListtab",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.pendingForInScanBTabs),
      callback: function($$v) {
        _vm.pendingForInScanBTabs = $$v
      },
      expression: "pendingForInScanBTabs"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Delivery"
    },
    on: {
      "click": function($event) {
        return _vm.switchTakeOverTabs('Delivery')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "DTO"
    },
    on: {
      "click": function($event) {
        return _vm.switchTakeOverTabs('DTO')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RTO"
    },
    on: {
      "click": function($event) {
        return _vm.switchTakeOverTabs('RTO')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row my-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('PendingForInScan')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending for return list"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-1",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalCountTakeover) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shipping Id')
    },
    attrs: {
      "type": "text",
      "id": "ShippingIdPendingForInScan",
      "placeholder": "Search By Shipping id",
      "name": "Shipping Id"
    },
    model: {
      value: (_vm.shippingIdPendingForInScan),
      callback: function($$v) {
        _vm.shippingIdPendingForInScan = $$v
      },
      expression: "shippingIdPendingForInScan"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getTakeoverPendingShipmentList()
      }
    }
  }, [_vm._v(" Search")])])], 1)], 1)])]), _vm._v(" "), _c('handover-shipment', {
    ref: "handoverShipments",
    attrs: {
      "isHandoverShipmentListLoader": _vm.isLoadingList,
      "totalHandoverShipmentcnt": _vm.totalCountTakeover,
      "pageCount1": _vm.pageCountTakeover,
      "HandoverShipmentList": _vm.shipmentListTakeover
    },
    on: {
      "getHandoverPaginationDataChild": _vm.getHandoverPaginationData
    }
  })], 1)])], 1)], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Pending For InScan"
    },
    model: {
      value: (_vm.mdlPendingForInScan),
      callback: function($$v) {
        _vm.mdlPendingForInScan = $$v
      },
      expression: "mdlPendingForInScan"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending For InScan")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('PFI')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingModal
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-tabs', {
    staticClass: "DeliveryshipmentListtab shipmentListtab",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.mdlPendingForInScanBTabs),
      callback: function($$v) {
        _vm.mdlPendingForInScanBTabs = $$v
      },
      expression: "mdlPendingForInScanBTabs"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Delivery",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTakoverModalTabs('Delivery')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "DTO",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTakoverModalTabs('DTO')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RTO",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTakoverModalTabs('RTO')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "22px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('PFI')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload Pending For Return List"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-1",
    staticStyle: {
      "font-size": "20px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalCountTakeoverModal))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shipping_Id')
    },
    attrs: {
      "type": "text",
      "id": "ShippingIdPendingForInScanMdl",
      "placeholder": "Enter Shipping Id",
      "name": "Shipping_Id"
    },
    model: {
      value: (_vm.shippingIdPendingForInScanMdl),
      callback: function($$v) {
        _vm.shippingIdPendingForInScanMdl = $$v
      },
      expression: "shippingIdPendingForInScanMdl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getTakeoverPendingShipmentList()
      }
    }
  }, [_vm._v(" Search")])])], 1)], 1)], 1)])])]), _vm._v(" "), _c('handover-shipment', {
    ref: "handoverShipmentsMdl",
    attrs: {
      "isHandoverShipmentListLoader": _vm.isLoadingModal,
      "totalHandoverShipmentcnt": _vm.totalCountTakeoverModal,
      "pageCount1": _vm.pageCountTakeoverModal,
      "HandoverShipmentList": _vm.shipmentListTakeoverModal
    },
    on: {
      "getHandoverPaginationDataChild": _vm.getHandoverPaginationDataModal
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('SS')
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "data-vv-scope": "form2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkShippingIdMdl('form2')
      }
    }
  }, [_c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Pending For Return"
    },
    model: {
      value: (_vm.mdlPendingForReturn),
      callback: function($$v) {
        _vm.mdlPendingForReturn = $$v
      },
      expression: "mdlPendingForReturn"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Available For Return")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('PFR')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingModal
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-tabs', {
    staticClass: "DeliveryshipmentListtab shipmentListtab",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.mdlPedingForReturnBTabs),
      callback: function($$v) {
        _vm.mdlPedingForReturnBTabs = $$v
      },
      expression: "mdlPedingForReturnBTabs"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Delivery",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModal('PFR', 'Forward')
      }
    }
  }), _vm._v(" "), (_vm.isRVPFeataureEnableForTesting) ? _c('b-tab', {
    attrs: {
      "title": "RVP",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModal('PFR', 'RVP')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "DTO",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModal('PFR', 'DTO')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RTO",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModal('PFR', 'RTO')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "mx-2",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "22px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('PFR')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload Pending For Return List"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-1",
    staticStyle: {
      "font-size": "20px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalCountMdl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.shipIdPFR == true ? 'alpha_num' : ''),
      expression: "shipIdPFR == true ? 'alpha_num' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form2.ShippingID')
    },
    attrs: {
      "type": "text",
      "id": "ShippingIdPendingForReturnMdl",
      "placeholder": "Enter Shipping Id",
      "name": "ShippingID"
    },
    model: {
      value: (_vm.shippingIdPendingForReturnMdl),
      callback: function($$v) {
        _vm.shippingIdPendingForReturnMdl = $$v
      },
      expression: "shippingIdPendingForReturnMdl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v(" Search")])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form2.ShippingID')),
      expression: "errors.has('form2.ShippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form2.ShippingID')))])], 1)], 1)])])]), _vm._v(" "), _c('pending-ForReturn', {
    attrs: {
      "pendingForReturnList": _vm.shipmentListMdl
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginateMdl),
      expression: "showPaginateMdl"
    }],
    ref: "paginateRefsMdl1",
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationShipmentListDataMdl,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('PFR')
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "SVC InScan Pending"
    },
    model: {
      value: (_vm.mdlSVCInScanPending),
      callback: function($$v) {
        _vm.mdlSVCInScanPending = $$v
      },
      expression: "mdlSVCInScanPending"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("SVC InScan Pending")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('SVC')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingModal
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-tabs', {
    staticClass: "DeliveryshipmentListtab shipmentListtab",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.mdlSVCInScanPendingBTabs),
      callback: function($$v) {
        _vm.mdlSVCInScanPendingBTabs = $$v
      },
      expression: "mdlSVCInScanPendingBTabs"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Delivery",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModal('SVC', 'Forward')
      }
    }
  }), _vm._v(" "), (_vm.isRVPFeataureEnableForTesting) ? _c('b-tab', {
    attrs: {
      "title": "RVP",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModal('SVC', 'RVP')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "DTO",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModal('SVC', 'DTO')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RTO",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModal('SVC', 'RTO')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "22px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('SVC')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload Pending For Return List"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-1",
    staticStyle: {
      "font-size": "20px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalCountMdl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.shipIdSVC == true ? 'alpha_num' : ''),
      expression: "shipIdSVC == true ? 'alpha_num' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form2.Shippingid')
    },
    attrs: {
      "type": "text",
      "id": "ShippingIdSvcInScanPendingMdl",
      "placeholder": "Enter Shipping Id",
      "name": "Shippingid"
    },
    model: {
      value: (_vm.shippingIdSvcInScanPendingMdl),
      callback: function($$v) {
        _vm.shippingIdSvcInScanPendingMdl = $$v
      },
      expression: "shippingIdSvcInScanPendingMdl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v(" Search")])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form2.Shippingid')),
      expression: "errors.has('form2.Shippingid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form2.Shippingid')))])], 1)], 1)])])]), _vm._v(" "), _c('svcInScan-Pending', {
    attrs: {
      "svcInScanPendingList": _vm.shipmentListMdl
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginateMdl),
      expression: "showPaginateMdl"
    }],
    ref: "paginateRefsMdl2",
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationShipmentListDataMdl,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('SVC')
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Shortage Shipments"
    },
    model: {
      value: (_vm.mdlShortageShipments),
      callback: function($$v) {
        _vm.mdlShortageShipments = $$v
      },
      expression: "mdlShortageShipments"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending For Return (RVP Shipments)")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('SS')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingModal
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-end",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "mx-2",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "22px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('SS')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload Pending For Return List"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-1",
    staticStyle: {
      "font-size": "20px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalCountMdl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.shipIdSS == true ? 'alpha_num' : ''),
      expression: "shipIdSS == true ? 'alpha_num' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form2.Shipping_Id')
    },
    attrs: {
      "type": "text",
      "id": "ShippingIdShortageShipmentsMdl",
      "placeholder": "Enter Shipping Id",
      "name": "Shipping_Id"
    },
    model: {
      value: (_vm.shippingIdShortageShipmentsMdl),
      callback: function($$v) {
        _vm.shippingIdShortageShipmentsMdl = $$v
      },
      expression: "shippingIdShortageShipmentsMdl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v(" Search")])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form2.Shipping_Id')),
      expression: "errors.has('form2.Shipping_Id')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form2.Shipping_Id')))])], 1)], 1)])])]), _vm._v(" "), _c('shortage-Shipments', {
    attrs: {
      "shortagePendingShipments": _vm.shipmentListMdl
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginateMdl),
      expression: "showPaginateMdl"
    }],
    ref: "paginateRefsMdl3",
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationShipmentListDataMdl,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('SS')
      }
    }
  }, [_vm._v("Close")])])])])])], 1)], 1), _vm._v(" "), ((_vm.returnArray && _vm.returnArray.length != 0)) ? _c('b-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTable),
      expression: "showTable"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Agent Handover Process")]), _vm._v(" "), _c('fieldset', [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shippingid")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Message")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.returnArray), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.message))])])
  }), _vm._v(" "), ((_vm.returnArray && _vm.returnArray.length == 0) || _vm.returnArray.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v("No Data found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')])], 1)])])]) : _vm._e()], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee28f258","hasScoped":false}!./src/views/components/agentreturntosvc/agentreturntosvc.component.html
// module id = 1063
// module chunks = 1